// @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import YouTubeIcon from "@mui/icons-material/YouTube";
// Material Kit 2 React components
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";

// Images
import logoCT from "assets/images/logo-ct-dark.png";
import gonganbeian from "assets/app/gonganbeian.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "时空笔记",
    image: logoCT,
    route: "/",
  },
  socials: [],
  menus: [
    {
      name: "关于我们",
      items: [{ name: "邮箱: 2954060395@qq.com", href: "/" }],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      &copy; {date} space-timex.com 版权所有{" "}
      <MKTypography
        component="a"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        ICP证：苏ICP备2025223663号
      </MKTypography>
      <MKBox
        component="img"
        src={gonganbeian}
        width={14}
        height={14}
        borderRadius="xl"
        shadow="lg"
        my="auto"
      />
      <MKTypography
        component="a"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32050602014003"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        苏公网安备32050602014003号
      </MKTypography>
    </MKTypography>
  ),
};
